import Row from './row'

Row.install = vue => {
  vue.component(Row.name, Row)
}

export default Row
